var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUzFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3162_225121)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 23,
    height: 5,
    fill: "#00B826"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 23,
    height: 1,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 23,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 23,
    height: 1,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 5,
    fill: "#0099B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3162_225121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 18,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUzFlag);
export default __webpack_public_path__ + "static/media/icon_uz_flag.8c954bb9c6bdd0c9a5c55aaaa579af09.svg";
export { ForwardRef as ReactComponent };